import React from "react";
import ReportGovernmentComponent from "./components/ReportGovernment";

const ReportGovernment = () => {
  return <ReportGovernmentComponent />;
};

export default ReportGovernment;
